import { VERSION } from '../../config';

export const isOutdated = (minimumFrontendVersion?: string) => {
  return (
    minimumFrontendVersion && Number(VERSION) < Number(minimumFrontendVersion)
  );
};
